export * from "-!../node_modules/babel-loader/lib/index.js!../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../node_modules/vue-loader/lib/index.js??vue-loader-options!./company-service.vue?vue&type=template&id=7f313817"


//////////////////
// WEBPACK FOOTER
// ./src/company-service.vue?vue&type=template&id=7f313817
// module id = 248
// module chunks = 0